module.exports = __webpack_public_path__ + "static/img/xinxihua1.6f08ff7d.png";